import { createFileRoute } from "@tanstack/react-router"
import PromptPage from "@/prompting/layout/PromptPage"
import type { Uuid } from "@/utils"

export const Route = createFileRoute("/(user)/t/$tenantSlug/prompts/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      draft?: string
      revision?: string
      runId?: Uuid
      history?: true
    },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { draft, revision, runId } = Route.useSearch()

  return (
    <PromptPage
      id={id}
      draftId={draft}
      revisionIdOrTag={revision}
      runId={runId}
    />
  )
}
